import type { StorageOfferWriteData } from 'src/apis/storage/types';
import { useAxios } from 'src/hooks/use-axios';
import { isConstraintViolation } from 'src/utils/is-constraint-violation';

type RequestOptions = {
  url: string;
  data: StorageOfferWriteData;
};

export function useStorageOfferCreate() {
  return useAxios(
    (axios, baseConfig, { url, data }: RequestOptions) =>
      axios.request({
        ...baseConfig,
        method: 'POST',
        url,
        data,
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        if (isConstraintViolation(error)) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );
}

export type StorageOfferCreateRequest = ReturnType<
  typeof useStorageOfferCreate
>;
